import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSnStore } from "../store/sn-store";
import { clearLazyComponentCache } from './add-component';

const DEBUG_KEY = 'sn-debug-enabled';

function ShowDebugInfo({ title, context, currentPage, widget }) {
  const [showDebug, setShowDebug] = useState(false);
  const store = useSnStore();
  const layout = store.layout;
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const debugParam = params.get('debug');
    if (debugParam === 'true') {
      localStorage.setItem(DEBUG_KEY, 'true');
    } else if (debugParam === 'false') {
      localStorage.removeItem(DEBUG_KEY);
    }
  }, [location.search]);

  const handleToggle = () => {
    setShowDebug(!showDebug);
  };

  const isDebug =
    (process.env.NODE_ENV === 'development' && localStorage.getItem(DEBUG_KEY) === 'true');

  if (!isDebug) return null;

  function showContextInfo(context) {
    if (context !== undefined) {
      return (
        <ul>
        <li>
            Content Name: <span>{context?.Name}</span>
          </li>
          <li>
            Content Type: <span>{context?.Type}</span>
          </li>
          <li>
            Content Path: <span>{context?.Path}</span>
          </li>
          <li>
            Content Lifespan:{" "}
            <span>{context?.EnableLifespan ? "true" : "false"}</span>
          </li>
          <li>
            Content ValidFrom: <span>{context?.ValidFrom}</span>
          </li>
          <li>
            Content ValidTill: <span>{context?.ValidTill}</span>
          </li>
          <li>
            <hr />
          </li>
        </ul>
      )
    }
  }

  function showWorkspaceInfo(context) {
    if (context !== undefined) {
      return (
        <ul>
          <li>
            Current Workspace Name:{" "}
            <span>
              {context?.Type === "Workspace"
                ? context?.Name
                : context?.Workspace?.Name}
            </span>
          </li>
          <li>
            Current Workspace Path:{" "}
            <span>
              {context?.Type === "Workspace"
                ? context?.Path
                : context?.Workspace?.Path}
            </span>
          </li>
          <li>
            <hr />
          </li>
        </ul>
      )
    }
  }

  function showPageInfo(currentPage, layout) {
    if (currentPage !== undefined) {
      return (
        <ul>
          <li>
            Page Name: <span>{currentPage?.Name}</span>
          </li>
          <li>
            Page Type: <span>{currentPage?.Type}</span>
          </li>
          <li>
            Page Path: <span>{currentPage?.Path}</span>
          </li>
          <li>
            Layout: <span>{layout}</span>
          </li>
          <li>
            <hr />
          </li>
        </ul>
      )
    }
  }

  function showWidgetInfo(widget) {
    if (widget !== undefined) {
      return (
        <ul>
          <li>
            Widget Name: <span>{widget?.Name}</span>
          </li>
          <li>
            Widget Type: <span>{widget?.Type}</span>
          </li>
          <li>
            Widget Path: <span>{widget?.Path}</span>
          </li>
          <li>
            Widget Component: <span>{widget?.ClientComponent}</span>
          </li>
          <li>
            Widget Query: <span>{widget?.ContentQuery}</span>
          </li>
          <li>
            Widget Context: <span>{widget?.ContextBinding}</span>
          </li>
          <li>
            Widget Custom Root: <span>{widget?.CustomRoot?.Path}</span>
          </li>
          <li>
            Widget Relative Path: <span>{widget?.RelativePath}</span>
          </li>
        </ul>
      )
    }
  }

  return (
    <div className="context-info debug-info">
      <div className="debug-info-button">
        <button title="show" onClick={handleToggle}>
          show
        </button>
        {process.env.NODE_ENV === 'development' && (
          <button
            title="Clear dynamic component cache"
            style={{ marginLeft: 8 }}
            onClick={clearLazyComponentCache}
          >
            clear cache
          </button>
        )}
      </div>
      <div
        className={`debug-info-details w3-left  ${showDebug ? "" : "hidden"}`}
      >
        <ul>
          <li>
            Component: <span>{title}</span>
          </li>
        </ul>
        <hr/>
        {showContextInfo(context)}
        {showWorkspaceInfo(context)}
        {showPageInfo(currentPage, layout)}
        {showWidgetInfo(widget)}
      </div>
    </div>
  );
}

export default ShowDebugInfo;
